import * as React from "react"
import {Box, Typography} from "@mui/material";
import { IconSeeker } from "@ui-seeker/core"
import {formatDate} from "@ui-seeker/utils";


export default function DynamicAssortmentTableDateTitle({ lastUpdateDate }) {

    return <Box sx={{ display: 'flex', alignItems:'center', justifyContent:'start', gap: 1 }} >
        <IconSeeker icon="boxes-stacked" iconWeight='thin' />
        <Box sx={{ display: 'flex', alignItems:'center' }}>
            <Typography variant={"h6"}>Dynamic Assortment -</Typography>
            <Typography variant={"h6"} sx={{ ml: 1, fontWeight: 'normal' }}>Last Update {formatDate(lastUpdateDate, { isString: true })}</Typography>
        </Box>
    </Box>

}
